<i [innerHTML]="icon"></i>
